import { render, staticRenderFns } from "./ProductManagementActions.vue?vue&type=template&id=351ff09e"
import script from "./ProductManagementActions.vue?vue&type=script&lang=js"
export * from "./ProductManagementActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports